import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CoreRouterActions } from './router.actions';
import { tap, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { RouterSelectors } from '.';

@Injectable()
export class CoreRouterEffects {
  actions$: Actions = inject(Actions);
  router: Router = inject(Router);
  #store: Store = inject(Store);

  /**
   * Effect to navigate to route
   */
  goToRoute$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CoreRouterActions.goToRoute),
        tap(({ path, options }) => {
          if (options?.external || path instanceof URL) {
            window.location.href = path instanceof URL ? path.toString() : path;
          } else {
            this.router.navigate([path], options);
          }
        }),
      ),
    {
      dispatch: false,
    },
  );

  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CoreRouterActions.navigate),
        tap(({ commands, options }) => {
          this.router.navigate(commands, options);
        }),
      ),
    {
      dispatch: false,
    },
  );

  redirectTo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CoreRouterActions.redirectTo),
        tap(({ path }) => {
          window.location.href = path;
        }),
      ),
    {
      dispatch: false,
    },
  );
}
